"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.HelmetProxy = void 0;
var _react = require("react");
var _reactHelmet = require("react-helmet");
var _jsxRuntime = require("react/jsx-runtime");
const HelmetProxy = function (_ref) {
  let {
    children
  } = _ref;
  const text = children.filter(function (i) {
    return i.type !== _react.Fragment;
  });
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactHelmet.Helmet, {
    "data-testid": "HelmetProxy",
    children: text
  });
};
exports.HelmetProxy = HelmetProxy;
var _default = exports.default = HelmetProxy;